import log from 'salvo-lite/log'
import VanillaModal from 'vanilla-modal'

const vanillaModal = new VanillaModal({
    open: '[data-modal-open]',
    close: '[data-modal-close]'
})

class Newsletter {
    constructor (theme, elem) {
        this._elem = elem
        this._submit = elem.querySelector('.submit-wrapper button')
        this._checkbox = elem.querySelector('.checkbox-wrapper input')
        this._checkStorage = JSON.parse(localStorage.getItem('greenwichNewsletterDismissed'))
    }

    onInit () {
        log.debug(this.constructor.name, 'Initialising...', this)
        if (this._checkbox) {
            this._checkbox.addEventListener('click', (e) => {
                this._submit.disabled = !this._checkbox.checked
            })
        } else {
            this._submit.disabled = false
        }
        if (!this._checkStorage) {
            setTimeout(() => {
                vanillaModal.open('#modal-1')
                localStorage.setItem('greenwichNewsletterDismissed', 'true')
            }, 3000)
        }
    }
}

export default Newsletter



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Newsletter.js